import React from 'react';
import { QuestionMark } from '@mui/icons-material';
import MessageNonTextDisplay from '../MessageNonTextDisplay';
import type { PartRendererProps } from './types';

const boxedIconStyle = { fontSize: 10, color: 'rgba(255, 255, 255, 0.7)' };

// Catch-all renderer for event types that aren't text/thought/function/
// waiting/suspended but still want the boxed presentation (InlineData,
// FileData, CodeExecutionResult, ExecutableCode, Video, Other, NotDefined).
const BoxedPart: React.FC<PartRendererProps> = ({
    part,
    message,
    preview,
    isLastInlineInGroup,
    onLinkClicked,
}) => {
    const title = part.eventType.toString();
    const content = part.rawDetails?.toString() ?? '';
    const markdownContent = `\`\`\`html\n\n${content}\n\n\`\`\``;
    const onDrawCodeBlock = (_c: string, _cl: string) => null;

    return (
        <MessageNonTextDisplay
            sessionId={message.sessionId ?? 'ND'}
            title={title}
            icon={<QuestionMark style={boxedIconStyle} />}
            content={markdownContent}
            part={part}
            preview={preview}
            onDrawCodeBlock={onDrawCodeBlock}
            onLinkClicked={onLinkClicked}
            isLastInlineInGroup={isLastInlineInGroup}
        />
    );
};

export default BoxedPart;
